import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  Typography,
  Tab,
  Tabs,
  CircularProgress,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Chip,
  Drawer,
  AvatarGroup,
  Avatar,
  Grid,
  TextField,
  Divider,
  Card,
  Tooltip
} from '@mui/material';
import {
  Description as DescriptionIcon,
  PictureAsPdf as PdfIcon,
  InsertDriveFile as GenericFileIcon,
  Image as ImageIcon,
  VideoLibrary as VideoIcon,
  Audiotrack as AudioIcon,
  TableChart as ExcelIcon,
  Article as WordIcon,
  Slideshow as PptIcon,
  Code as CodeIcon,
  FolderZip as ArchiveIcon,
  TextFields as TextIcon,
  Assessment as CsvIcon,
  DataObject as JsonIcon
} from '@mui/icons-material';
import './ViewShipment.css';
import {
  GetClaimedShipmentDetails,
  GetProofOfDelivery,
  GetQuoteDetail,
  GetShipmentDetails,
  TrackShipmentRequest,
  UpdateShipmentContacts,
  UpdateShipmentDetail
} from '../../apis/Agency';
import { useSelector } from 'react-redux';
import { CardContent } from '@mui/material';
import { Folder } from '@mui/icons-material';
import { ErrorToast } from '../../components/Toasts';
import { Col, Row } from 'reactstrap';
import TrackShipmentDetails from '../TrackShipment/TrackShipmentDetails';
import DownloadIcon from '@mui/icons-material/Download';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { base_logo_url } from '../../apis/constants';
import CloseIcon from '@mui/icons-material/Close';
import Barcode from 'react-barcode';
import html2pdf from 'html2pdf.js';
import NoLogo from '../../assets/carrier logos/No Logo.png';
import './bol_table.css';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { useReactToPrint } from 'react-to-print';
import { formatDateUTC, formatPhoneNumber } from '../../apis/Utils';
import { useMediaQuery, useTheme } from '@mui/material';
import PackagingSlip from './PackagingSlip';
import BillOfLading from './BillOfLading';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
// VERTICAL
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role='tabpanel'
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ px: 1, width: '115%' }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired
};

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    'aria-controls': `vertical-tabpanel-${index}`
  };
}

// HORIZONTAL

function TabPanelX(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role='tabpanel'
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ px: 3, py: 1, maxWidth: '100%' }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanelX.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired
};

function ViewShipment(props) {
  const claimDetailsAllowed = props?.claimDetailsAllowed;
  console.log(props, 'claimDetailsAllowed');
  const getFileTypeInfo = doc => {
    const fileType = doc.fileType?.toLowerCase() || '';
    const fileName = doc.name?.toLowerCase() || '';
    const filePath = doc.filePath?.toLowerCase() || '';

    // Check by file extension first
    const getExtension = () => {
      const sources = [fileName, filePath];
      for (const source of sources) {
        const match = source.match(/\.([a-z0-9]+)$/);
        if (match) return match[1].toLowerCase();
      }
      return '';
    };

    const extension = getExtension();

    // Image types
    if (
      fileType.startsWith('image/') ||
      [
        'jpg',
        'jpeg',
        'png',
        'gif',
        'bmp',
        'webp',
        'svg',
        'tiff',
        'tif'
      ].includes(extension)
    ) {
      return {
        icon: <ImageIcon sx={{ fontSize: 40 }} />,
        color: '#4CAF50',
        bgColor: '#E8F5E9',
        label: 'Image'
      };
    }

    // PDF
    if (fileType.includes('pdf') || extension === 'pdf') {
      return {
        icon: <PdfIcon sx={{ fontSize: 40 }} />,
        color: '#F44336',
        bgColor: '#FFEBEE',
        label: 'PDF'
      };
    }

    // Excel/Spreadsheet
    if (
      fileType.includes('excel') ||
      fileType.includes('spreadsheet') ||
      ['xls', 'xlsx', 'xlsm', 'xlsb', 'csv'].includes(extension)
    ) {
      return {
        icon: <ExcelIcon sx={{ fontSize: 40 }} />,
        color: '#2196F3',
        bgColor: '#E3F2FD',
        label: extension === 'csv' ? 'CSV' : 'Excel'
      };
    }

    // Word
    if (
      fileType.includes('word') ||
      fileType.includes('document') ||
      ['doc', 'docx', 'docm', 'dot', 'dotx'].includes(extension)
    ) {
      return {
        icon: <WordIcon sx={{ fontSize: 40 }} />,
        color: '#2196F3',
        bgColor: '#E3F2FD',
        label: 'Word'
      };
    }

    // PowerPoint
    if (
      fileType.includes('powerpoint') ||
      fileType.includes('presentation') ||
      ['ppt', 'pptx', 'pptm', 'pot', 'potx'].includes(extension)
    ) {
      return {
        icon: <PptIcon sx={{ fontSize: 40 }} />,
        color: '#FF9800',
        bgColor: '#FFF3E0',
        label: 'PowerPoint'
      };
    }

    // Text files
    if (
      fileType.includes('text') ||
      ['txt', 'rtf', 'md', 'log'].includes(extension)
    ) {
      return {
        icon: <TextIcon sx={{ fontSize: 40 }} />,
        color: '#795548',
        bgColor: '#EFEBE9',
        label: 'Text'
      };
    }

    // Archive files
    if (['zip', 'rar', '7z', 'tar', 'gz'].includes(extension)) {
      return {
        icon: <ArchiveIcon sx={{ fontSize: 40 }} />,
        color: '#FF9800',
        bgColor: '#FFF3E0',
        label: 'Archive'
      };
    }

    // Video
    if (
      fileType.startsWith('video/') ||
      ['mp4', 'avi', 'mov', 'wmv', 'flv', 'mkv'].includes(extension)
    ) {
      return {
        icon: <VideoIcon sx={{ fontSize: 40 }} />,
        color: '#9C27B0',
        bgColor: '#F3E5F5',
        label: 'Video'
      };
    }

    // Audio
    if (
      fileType.startsWith('audio/') ||
      ['mp3', 'wav', 'aac', 'flac', 'ogg'].includes(extension)
    ) {
      return {
        icon: <AudioIcon sx={{ fontSize: 40 }} />,
        color: '#9C27B0',
        bgColor: '#F3E5F5',
        label: 'Audio'
      };
    }

    // Code files
    if (
      [
        'js',
        'jsx',
        'ts',
        'tsx',
        'html',
        'css',
        'py',
        'java',
        'cpp',
        'c',
        'php',
        'json',
        'xml'
      ].includes(extension)
    ) {
      return {
        icon: <CodeIcon sx={{ fontSize: 40 }} />,
        color: '#607D8B',
        bgColor: '#ECEFF1',
        label: extension.toUpperCase()
      };
    }

    // CSV specifically
    if (extension === 'csv') {
      return {
        icon: <CsvIcon sx={{ fontSize: 40 }} />,
        color: '#4CAF50',
        bgColor: '#E8F5E9',
        label: 'CSV'
      };
    }

    // JSON
    if (extension === 'json') {
      return {
        icon: <JsonIcon sx={{ fontSize: 40 }} />,
        color: '#FF9800',
        bgColor: '#FFF3E0',
        label: 'JSON'
      };
    }

    // TIFF specific (if not caught by image check)
    if (extension === 'tiff' || extension === 'tif') {
      return {
        icon: <ImageIcon sx={{ fontSize: 40 }} />,
        color: '#4CAF50',
        bgColor: '#E8F5E9',
        label: 'TIFF'
      };
    }

    // Default
    return {
      icon: <GenericFileIcon sx={{ fontSize: 40 }} />,
      color: '#757575',
      bgColor: '#FAFAFA',
      label: extension ? extension.toUpperCase() : 'File'
    };
  };

  // Helper function to format file size
  const formatFileSize = bytes => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  };
  const contentRef = useRef(null);

  const [openPrintPDfDialogData, setOpenPrintPDfDialogData] = useState('');
  const [numberOfPrintsColmnVise, setNumberOfPrintsColmnVise] = useState(1);
  const [selectedPrintOption, setSelectedPrintOption] = useState(1);
  const [numberOfPrints, setNumberOfPrints] = useState(1);

  const [viewShipmentsDetails, setViewShipmentsDetails] = useState([]);

  const handleFetchShipmentsDetails = row => {
    GetShipmentDetails(rowData.shipmentId)
      .then(res => res.status === 200 && setViewShipmentsDetails(res.data.data))
      .catch(err => ErrorToast(err?.message));
  };

  useEffect(() => {
    handleFetchShipmentsDetails(props.rowData.shipmentId);
  }, []);

  const handleAfterPrint = React.useCallback(() => {}, []);

  const handleBeforePrint = React.useCallback(() => {
    return Promise.resolve();
  }, []);

  const handlePrint = useReactToPrint({
    // contentRef: contentRef,
    content: () => contentRef.current,
    documentTitle: `${openPrintPDfDialogData.carrierName} labels`,
    onAfterPrint: handleAfterPrint,
    onBeforePrint: handleBeforePrint
  });
  // At the top of your component or before the JSX block
  const originDetails = viewShipmentsDetails?.find(
    item => item.itemType === 'Pickup'
  );
  const destinationDetails = viewShipmentsDetails?.find(
    item => item.itemType === 'Delivery'
  );
  const handleDateTimeShow = (timeStamp, type) => {
    const dateTimeString = timeStamp + 'Z';
    const dateTime = new Date(dateTimeString);
    const date = new Date(dateTimeString);
    const bolDate = new Date(timeStamp);
    const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    const timeOptions = new Intl.DateTimeFormat('default', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric',
      timeZone: userTimeZone
    }).format(dateTime);

    const dateOptions = {
      // weekday: 'short',
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    };

    const formattedDate = date.toLocaleDateString(undefined, dateOptions);
    const options = { year: 'numeric', month: 'numeric', day: 'numeric' };
    const formattedBolDate = bolDate.toLocaleDateString('en-US', options);
    if (type === 'time') {
      return timeOptions;
    }
    if (type === 'date') {
      return formattedDate;
    }
    if (type === 'bol') {
      return formattedBolDate;
    }
  };
  const shipmentStatus = props?.rowData?.shipmentStatus;
  const [trackShipmentData, setTrackShipmentData] = useState(null);
  const getStatusIcon = status => {
    console.log(status, 'status');
    switch (status) {
      case 'Paid':
        return (
          <CheckCircleIcon sx={{ mx: -1 }} fontSize='11' color='success' />
        );
      case 'Rejected':
        return <CancelIcon sx={{ mx: -1 }} fontSize='11' color='error' />;
      case 'Submitted':
        return (
          <HourglassEmptyIcon sx={{ mx: -1 }} fontSize='11' color='info' />
        );
      default:
        return null;
    }
  };
  const handleSuccessTrackShip = apiRes => {
    setLoader(false);
    setTrackShipmentData(apiRes);
    // history.push({
    //   pathname: '/track-shipment',
    //   state: { trackShipmentData: apiRes }
    // });
  };
  const AgencyID = useSelector(state => state.userDetails.agencyLoginID);
  const [, setBlobUrlPOD] = useState('');
  const [loader, setLoader] = useState(false);
  const [docLoader, setDocLoader] = useState(false);
  const [historyError, setHistoryError] = useState(false);
  const [PodDocLoader, setPodDocLoader] = useState(false);
  const [claimDetails, setClaimDetails] = useState({});
  const [viewType, setViewType] = useState('Track');
  const AgencyAdminDetails = useSelector(
    state => state.user.AgencyAdminDetails
  );
  const handleTrackShipmentRequest = (selectedRowData, event, type) => {
    if (type === 'history') {
      setViewType(type);
      event.stopPropagation();
    } else {
      setLoader(true);
      event.stopPropagation();
      const obj = {
        carrierInfo: {
          id: selectedRowData?.carrierId ? selectedRowData.carrierId : 0,
          name: selectedRowData?.carrierName ? selectedRowData.carrierName : '',
          logo: ''
        },
        proNumber: selectedRowData?.proNumber,
        shipmentId: selectedRowData?.shipmentId,
        locationId: selectedRowData?.locationId,
        shipmentType: selectedRowData?.shipmentType,
        agencyId: AgencyID ? AgencyID : 0
      };

      TrackShipmentRequest(obj)
        .then(res => {
          if (res.status === 200) {
            handleSuccessTrackShip(res.data);
          } else if (res.status === 204) {
            setLoader(false);
            ErrorToast('No tracking information available for this shipment.');
          }
        })
        .catch(err => {
          setLoader(false);
          ErrorToast(JSON.stringify(err?.response?.data));
        });
    }
  };

  const handleOpenFile = filePath => {
    window.open(filePath, '_blank');
  };

  const viewPOD = (fileType, base64Data, urls, fileName) => {
    let mimeType;
    if (base64Data !== null) {
      switch (fileType.toLowerCase()) {
        case 'pdf':
        case '.pdf':
          mimeType = 'application/pdf';
          break;
        case 'tif':
        case 'tiff':
        case 'tifv':
          mimeType = 'image/tiff';
          break;
        case '.gif':
        case 'gif':
          mimeType = 'image/gif';
          break;
        case 'jpg':
        case '.jpg':
          mimeType = 'image/jpg';
          break;
        default:
          ErrorToast('Unsupported file type');
          return;
      }

      const linkSource = `data:${mimeType};base64,${base64Data}`;
      const downloadLink = document.createElement('a');
      downloadLink.href = linkSource;

      // Set the download attribute with the correct file extension
      downloadLink.download = fileName.endsWith(`.${fileType}`)
        ? fileName
        : `${fileName}.${fileType}`;

      // Trigger the download
      downloadLink.click();
    }
    if (urls && Array.isArray(urls)) {
      urls.forEach(url => {
        if (url) {
          window.open(url, '_blank');
        }
      });
    }
  };

  const getCliamDetails = () => {
    GetClaimedShipmentDetails(rowData?.shipmentId)
      .then(res => res.status === 200 && setClaimDetails(res.data.data))
      .catch(err => ErrorToast(err?.message));
  };

  const handleProofOfDeliveryRequest = status => {
    setPodDocLoader(true);
    const obj = {
      carrier: {
        id: rowData?.carrierId ? rowData.carrierId : 0,
        name: rowData?.carrierName ? rowData.carrierName : 'string',
        logo: 'string'
      },
      proNumber: rowData?.proNumber.trim(),
      shipmentId: rowData?.shipmentId,
      locationId: rowData?.locationId,
      agencyId: AgencyID ? AgencyID : 0
    };
    GetProofOfDelivery(obj)
      .then(res => {
        res.status === 200 && setPodDocLoader(false);
        viewPOD(
          res.data.fileExtension,
          res.data.fileBase64,
          res.data.urLs,
          `Proof of Delivery (${obj.carrier.name}  ${obj.proNumber})`
        );
      })
      .catch(err => {
        setPodDocLoader(false);
        setBlobUrlPOD(null);
        ErrorToast(JSON.stringify(err?.response?.data));
      });
  };

  const rowData = props?.rowData;

  // Vertical

  const [valueY, setValueY] = useState(0);
  const [shipperApiMsgs, setShipperApiMsgs] = useState('');
  const [carrierApiMsgs, setCarrierApiMsgs] = useState('');
  const [openPrintPDfDialog, setOpenPrintPDfDialog] = useState(false);
  const [openLabelsDialog, setOpenLabelsDialog] = useState(false);
  const [openPDfPackagingSlip, setOpenPDfPackagingSlip] = useState(false);

  const [TLCoressPDrawer, setTLCoressPDrawer] = useState(false);
  const handleCloaseTLCoressPDrawer = () => {
    setValueY(0);
    setTLCoressPDrawer(false);
  };

  const handleSuccessResponse = apiRes => {
    setHistoryError(false);
    const carrierData = apiRes.data.data.details.filter(
      items => items.actionByFlag.toLowerCase() === 'carrier'
    );

    setShipperApiMsgs(apiRes.data.data.details);
    setCarrierApiMsgs(carrierData);
    setDocLoader(false);
  };

  const handleGetCorrHistory = apiRes => {
    if (rowData?.sessionId) {
      GetQuoteDetail(rowData?.sessionId)
        .then(res => res.status === 200 && handleSuccessResponse(res))
        .catch(err => {
          setDocLoader(false);
          ErrorToast(err?.message);
        });
    } else {
      // ErrorToast('No history found against this shipment!');
      setHistoryError(true);
      setDocLoader(false);
    }
  };

  const handleGetQuote = () => {
    handleGetCorrHistory();
    // GetQuote(rowData?.quoteId)
    //   .then(res => {
    //     res.status === 200 && handleGetCorrHistory(res.data.data);
    //     setDocLoader(false);
    //   })
    //   .catch(err => console.log(err, 'TL quote Err----->>>>'));
  };
  const handleChangeY = (event, newValue) => {
    setValueY(newValue);
    if (newValue === 3) {
      setDocLoader(true);
      handleGetQuote();
    }
  };

  // Horizontal
  const [valueX] = useState(0);

  const [, setIsFullScreen] = useState(false);

  useEffect(() => {
    document.addEventListener('fullscreenchange', handleFullScreenChange);

    return () => {
      document.removeEventListener('fullscreenchange', handleFullScreenChange);
    };
  }, []);

  const handleFullScreenChange = () => {
    setIsFullScreen(document.fullscreenElement !== null);
  };

  const removeTableCss = finalRes => {
    const regexPattern = /<style[^>]*>([\s\S]*?)<\/style>/gi;

    // Remove table styles including borders
    const updatedHtml = finalRes.replace(regexPattern, (match, styles) => {
      const stylesWithoutTable = styles.replace(
        /(?:table|td|th)\s*\{[^}]*\}/gi,
        ''
      );
      return `<style>${stylesWithoutTable} table { font-size: 12px; } td { padding: 10px; }</style>`;
    });
    return updatedHtml;
  };

  const handleCorresHistory = apiRes => {
    // Regex pattern to capture and replace font-size in table styles
    const fontSizeToUpdate = removeTableCss(apiRes);

    return fontSizeToUpdate;

    // removeTableCss(updatedHtml);
  };

  const handlePDFPrintClose = () => {
    setOpenPrintPDfDialog(false);
    // setNumberOfPrintsColmnVise(1);
  };

  const hanldeCloseLabels = () => {
    setOpenLabelsDialog(false);
    setOpenPrintPDfDialogData('');
    setNumberOfPrints(1);
    setNumberOfPrintsColmnVise(1);
    setSelectedPrintOption(1);
  };
  // const generatePDF = async () => {
  //   const element = document.getElementById('pdf-content');

  //   const pageSize = {
  //     width: 900,
  //     height: 1150
  //   };

  //   const pdfOptions = {
  //     // margin: 1,
  //     filename: 'TMS Bill Of Lading.pdf',
  //     // filename: 'label.pdf',
  //     // image: { type: 'jpeg', quality: 1.0 },
  //     html2canvas: {
  //       scale: 4, // Adjust scale as needed
  //       logging: true // Enable logging if needed
  //     },
  //     jsPDF: {
  //       unit: 'pt',
  //       format: [pageSize.width, pageSize.height],
  //       // format: 'a4',
  //       orientation: 'portrait'
  //     }
  //   };

  //   await html2pdf(element, pdfOptions);
  // };
  const generatePackagingSlipPdf = async () => {
    const element = document.getElementById('pdf-content');

    const pageSize = {
      width: 800,
      height: 1050
    };

    const pdfOptions = {
      // margin: 1,
      filename: 'TMS Packaging Slip.pdf',
      // filename: 'label.pdf',
      // image: { type: 'jpeg', quality: 1.0 },
      html2canvas: {
        scale: 6, // Adjust scale as needed
        logging: true // Enable logging if needed
      },
      jsPDF: {
        unit: 'pt',
        format: [pageSize.width, pageSize.height],
        // format: 'a4',
        orientation: 'portrait'
      }
    };

    await html2pdf(element, pdfOptions);
  };
  const handlePdfPackagingClose = () => {
    setOpenPDfPackagingSlip(false);
  };

  // const generatePDF = async (cName, pgWidth, pgHeight, fileName) => {
  //   const element = document.getElementById('pdf-content');
  //   const widthInPoints = 4 * 72; // 4 inches to points
  //   const heightInPoints =
  //     numberOfPrintsColmnVise === 1
  //       ? 6.1 * 72
  //       : numberOfPrintsColmnVise ===
  //       ? 6.05 * 72
  //       : 6.01 * 72;
  //   const pageSize = {
  //     width: fileName === 'bol' ? pgWidth : widthInPoints,
  //     height: fileName === 'bol' ? pgHeight : heightInPoints
  //   };

  //   const pdfOptions = {
  //     // margin: 1,
  //     filename: `${cName}_${fileName}.pdf`,
  //     // filename: 'label.pdf',
  //     // image: { type: 'jpeg', quality: 1.0 },
  //     html2canvas: {
  //       scale: 3, // Adjust scale as needed
  //       logging: true // Enable logging if needed
  //     },
  //     jsPDF: {
  //       unit: 'pt',
  //       format: [pageSize.width, pageSize.height],
  //       // format: 'a4',
  //       orientation: 'portrait'
  //     }
  //   };

  //   await html2pdf(element, pdfOptions);
  // };
  const handleUpdateBOLDialog = selectedShipment => {
    setFormData({
      shipmentId: Number(selectedShipment?.shipmentId) ?? 0,
      originOpenTime: selectedShipment?.pickupStartTime ?? '',
      originCloseTime: selectedShipment?.pickupEndTime ?? '',
      destinationOpenTime: selectedShipment?.deliverStartTime ?? '',
      destinationCloseTime: selectedShipment?.deliverEndTime ?? '',
      origin: {
        personName: selectedShipment?.originContactPerson ?? '',
        phoneNumber: selectedShipment?.originContactPhone ?? '',
        faxNumber: '',
        companyName: selectedShipment?.originCompany ?? '',
        phoneExtension: '',
        email: selectedShipment?.originContactEmail ?? ''
      },
      destination: {
        personName: selectedShipment?.destinationContactPerson ?? '',
        phoneNumber: selectedShipment?.destinationContactPhone ?? '',
        faxNumber: '',
        companyName: selectedShipment?.destinationCompany ?? '',
        phoneExtension: '',
        email: selectedShipment?.destinationContactEmail ?? ''
      }
    });
    props?.handleCloseBolDialog(true);
  };

  const generatePDF = async (cName, pgWidth, pgHeight, fileName) => {
    const element = document.getElementById('pdf-content');

    if (fileName !== 'bol') {
      // Your Previous Code
      const widthInPoints = 4 * 72; // 4 inches to points
      const heightInPoints =
        numberOfPrintsColmnVise === 1
          ? 6.1 * 72
          : numberOfPrintsColmnVise === 2
            ? 6.05 * 72
            : 6.01 * 72;

      const pageSize = {
        width: widthInPoints,
        height: heightInPoints
      };

      const pdfOptions = {
        filename: `${cName}_${fileName}.pdf`,
        html2canvas: {
          scale: 3,
          logging: true
        },
        jsPDF: {
          unit: 'pt',
          format: [pageSize.width, pageSize.height],
          orientation: 'portrait'
        }
      };

      await html2pdf(element, pdfOptions);
    } else {
      // New Dynamic Code for Other Cases
      const element = document.getElementById('pdf-content');

      // Measure the height of the content dynamically
      const contentHeight = element.scrollHeight; // Get actual content height
      const heightInPoints =
        rowData?.shipmentType === 'TL'
          ? contentHeight - (contentHeight * 1) / 60
          : contentHeight - (contentHeight * 25) / 100;

      const pageSize = {
        width: pgWidth, // Default 4 inches in points
        height: heightInPoints // Dynamic height
      };
      console.log(pageSize, 'pageSize');
      const pdfOptions = {
        filename: `${cName}_${fileName}.pdf`,
        html2canvas: {
          scale: 3,
          logging: false
        },
        pagebreak: { mode: ['avoid-all', 'css', 'legacy'] },
        jsPDF: {
          unit: 'pt',
          format: [pageSize.width, pageSize.height],
          orientation: 'portrait'
        }
      };

      await html2pdf(element, pdfOptions);
    }
  };

  const printData = rowData => {
    GetShipmentDetails(rowData.shipmentId)
      .then(res => {
        if (res.status === 200) {
          if (rowData.shipmentType === 'Parcel') {
            window.open(rowData.dispatchInput1, '_blank');
          } else {
            rowData.details = res.data.data;
            setOpenLabelsDialog(true);
            setOpenPrintPDfDialogData(rowData);
          }
        }
      })
      .catch(err => ErrorToast(err?.message));
  };

  const handleChangeNoOfPrints = e => {
    setNumberOfPrintsColmnVise(0);
    setNumberOfPrints(0);

    // Update the states based on the selected value
    const value = parseInt(e.target.value, 10);
    setSelectedPrintOption(value);

    switch (value) {
      case 1:
        setNumberOfPrintsColmnVise(1);
        setNumberOfPrints(1);
        break;
      case 2:
        setNumberOfPrintsColmnVise(2);
        setNumberOfPrints(1);
        break;
      case 4:
        setNumberOfPrintsColmnVise(4);
        setNumberOfPrints(1);
        break;
      case 6:
        setNumberOfPrintsColmnVise(6);
        setNumberOfPrints(1);
        break;
      default:
        break;
    }
  };

  // const mainCharges = rowData?.surchargesList
  //   ?.sort(applySubChargesSort)
  //   .filter(s => !accessorialDescriptions.includes(s.description));

  // const accessorialCharges = rowData?.surchargesList
  //   ?.sort(applySubChargesSort)
  //   .filter(s => accessorialDescriptions.includes(s.description));

  // const maxLength = Math.max(mainCharges.length, accessorialCharges.length);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [formData, setFormData] = useState({});
  const [, setOpen] = useState(false);
  const [bolLoader, setBolLoader] = useState(false);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    setBolLoader(props?.loading);
  }, [props?.loading]);

  const handleChange = (section, field, value) => {
    setFormData(prev => {
      if (section === 'origin' || section === 'destination') {
        return {
          ...prev,
          [section]: {
            ...prev[section],
            [field]: value
          }
        };
      } else {
        return {
          ...prev,
          [field]: value
        };
      }
    });

    setErrors(prev => {
      const next = { ...prev, [section]: { ...(prev[section] || {}) } };

      // --- Email Validation ---
      if (field === 'email') {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const msg = emailRegex.test(value) ? '' : 'Please enter a valid email';
        if (msg) {
          next[section].email = msg;
        } else {
          delete next[section].email;
        }
      }

      // --- Mandatory Fields Validation ---
      if (
        (section === 'origin' || section === 'destination') &&
        ['companyName', 'personName', 'phoneNumber'].includes(field)
      ) {
        if (!value?.trim()) {
          next[section][field] = `${
            field === 'companyName'
              ? 'Company Name'
              : field === 'personName'
                ? 'Contact Name'
                : 'Phone'
          } is required`;
        } else {
          delete next[section][field];
        }

        // --- Phone Length Validation (digits only) ---
        if (field === 'phoneNumber') {
          const digitsOnly = value.replace(/\D/g, ''); // remove formatting
          if (digitsOnly.length !== 10) {
            next[section][field] = 'Phone number must be 10 digits';
          }
        }
      }

      // clean up section if no errors
      if (Object.keys(next[section]).length === 0) {
        delete next[section];
      }

      return next;
    });
  };

  const handleClose = () => {
    setOpen(false);
  };
  const handleSave = async () => {
    setBolLoader(true);

    if (Object.keys(errors).length === 0) {
      try {
        const res = await UpdateShipmentContacts(formData);

        if (res.status === 200) {
          // Ensure we always deal with an array
          const detailsArray = Array.isArray(viewShipmentsDetails)
            ? viewShipmentsDetails
            : [viewShipmentsDetails];

          // Run sequentially
          for (const detail of detailsArray) {
            const detailsRes = await UpdateShipmentDetail(detail);

            if (detailsRes.status !== 200) {
              ErrorToast('Something went wrong while updating shipment');
              setBolLoader(false);
              return;
            }
          }

          // All succeeded
          await handleFetchShipmentsDetails(props.rowData.shipmentId);
          setBolLoader(false);

          // successToast('BOL updated successfully!');
          if (props?.onUpdated) {
            props.onUpdated();
            handleClose();
          }
        } else {
          setBolLoader(false);
          ErrorToast('Error while updating shipment contacts');
        }
      } catch (err) {
        console.error(err);
        setBolLoader(false);
        ErrorToast(err?.message || 'Error while updating shipment');
      }
    } else {
      setBolLoader(false);
      ErrorToast('Please fix form errors before saving');
    }
  };

  const damagedOrShortageClaim =
    claimDetails?.claimType === 'Damage' ||
    claimDetails?.claimType === 'Shortage';
  const concealedDamagedClaim = claimDetails?.claimType === 'Concealed Damage';
  return (
    <div className='d-flex ' style={{ justifyContent: 'center' }}>
      {/* <ToastContainer
        position='top-center'
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      /> */}
      <Box
        sx={{
          // bgcolor: 'background.paper',
          // backgroundColor: 'red',
          display: 'flex',
          width: '100%',
          borderRadius: '5px',
          // marginTop: -20
          p: 3,
          height: 'auto'
        }}
      >
        <Dialog
          open={props?.updateBOLDialg}
          onClose={() => {
            setFormData({});
            props?.handleCloseBolDialog(false);
          }}
          maxWidth='sm'
          fullWidth
        >
          <DialogTitle>Update BOL</DialogTitle>

          <DialogContent dividers>
            <Grid container spacing={2}>
              {/* Shipper */}
              <Grid item xs={12}>
                <Typography fontWeight={500}>Shipper Details</Typography>
              </Grid>
              <Grid item xs={6}>
                <TextField
                  size='small'
                  fullWidth
                  label='Company Name'
                  value={formData.origin?.companyName}
                  onChange={e =>
                    handleChange('origin', 'companyName', e.target.value)
                  }
                  error={Boolean(errors.origin?.companyName)}
                  helperText={errors.origin?.companyName}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  size='small'
                  fullWidth
                  label='Contact Name'
                  value={formData.origin?.personName}
                  onChange={e =>
                    handleChange('origin', 'personName', e.target.value)
                  }
                  error={Boolean(errors.origin?.personName)}
                  helperText={errors.origin?.personName}
                />
              </Grid>

              <Grid item xs={6}>
                <TextField
                  size='small'
                  fullWidth
                  label='Phone'
                  inputProps={{ maxLength: 14 }}
                  value={formatPhoneNumber(formData.origin?.phoneNumber)}
                  onChange={e =>
                    handleChange(
                      'origin',
                      'phoneNumber',
                      formatPhoneNumber(e.target.value)
                    )
                  }
                  error={Boolean(errors.origin?.phoneNumber)}
                  helperText={errors.origin?.phoneNumber}
                />
              </Grid>

              <Grid item xs={6}>
                <TextField
                  size='small'
                  fullWidth
                  label='Email'
                  value={formData.origin?.email}
                  onChange={e =>
                    handleChange('origin', 'email', e.target.value)
                  }
                  error={Boolean(errors.origin?.email)}
                  helperText={errors.origin?.email}
                />
              </Grid>

              <Grid item xs={12}>
                <Grid
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'flex-end'
                  }}
                >
                  <Grid>
                    <Typography fontWeight={500}>Pickup Hours</Typography>
                  </Grid>
                  <Grid
                    container
                    gap={1}
                    sx={{
                      mt: 1,
                      display: 'flex',
                      justifyContent: 'space-between'
                    }}
                  >
                    <Grid sm={5.8}>
                      <TextField
                        size='small'
                        label='Open Time'
                        InputLabelProps={{
                          shrink: true
                        }}
                        value={formData?.originOpenTime || ''}
                        onChange={e => {
                          handleChange('', 'originOpenTime', e.target.value);
                        }}
                        type='time'
                        fullWidth
                      />
                    </Grid>
                    <Grid sm={5.8}>
                      <TextField
                        size='small'
                        label='Close Time'
                        value={formData?.originCloseTime || ''}
                        InputLabelProps={{
                          shrink: true
                        }}
                        onChange={e => {
                          handleChange('', 'originCloseTime', e.target.value);
                        }}
                        type='time'
                        fullWidth
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>

              {/* Consignee */}
              <Grid item xs={12} mt={2}>
                <Typography fontWeight={500}>Consignee Details</Typography>
              </Grid>
              <Grid item xs={6}>
                <TextField
                  size='small'
                  fullWidth
                  label='Company Name'
                  value={formData.destination?.companyName}
                  onChange={e =>
                    handleChange('destination', 'companyName', e.target.value)
                  }
                  error={Boolean(errors.destination?.companyName)}
                  helperText={errors.destination?.companyName}
                />
              </Grid>

              <Grid item xs={6}>
                <TextField
                  size='small'
                  fullWidth
                  label='Contact Name'
                  value={formData.destination?.personName}
                  onChange={e =>
                    handleChange('destination', 'personName', e.target.value)
                  }
                  error={Boolean(errors.destination?.personName)}
                  helperText={errors.destination?.personName}
                />
              </Grid>

              <Grid item xs={6}>
                <TextField
                  size='small'
                  fullWidth
                  label='Phone'
                  inputProps={{ maxLength: 14 }}
                  value={formatPhoneNumber(formData.destination?.phoneNumber)}
                  onChange={e =>
                    handleChange(
                      'destination',
                      'phoneNumber',
                      formatPhoneNumber(e.target.value)
                    )
                  }
                  error={Boolean(errors.destination?.phoneNumber)}
                  helperText={errors.destination?.phoneNumber}
                />
              </Grid>

              <Grid item xs={6}>
                <TextField
                  size='small'
                  fullWidth
                  label='Email'
                  value={formData.destination?.email}
                  onChange={e =>
                    handleChange('destination', 'email', e.target.value)
                  }
                  error={Boolean(errors.destination?.email)}
                  helperText={errors.destination?.email}
                />
              </Grid>

              <Grid item xs={12}>
                <Grid
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'flex-end'
                  }}
                >
                  <Grid>
                    <Typography fontWeight={500}>Delivery Hours</Typography>
                  </Grid>
                  <Grid
                    container
                    gap={1}
                    sx={{
                      mt: 1,
                      display: 'flex',
                      justifyContent: 'space-between'
                    }}
                  >
                    <Grid sm={5.8}>
                      <TextField
                        size='small'
                        label='Open Time'
                        InputLabelProps={{
                          shrink: true
                        }}
                        value={formData?.destinationOpenTime || ''}
                        onChange={e => {
                          handleChange(
                            '',
                            'destinationOpenTime',
                            e.target.value
                          );
                        }}
                        type='time'
                        fullWidth
                      />
                    </Grid>
                    <Grid sm={5.8}>
                      <TextField
                        size='small'
                        label='Close Time'
                        InputLabelProps={{
                          shrink: true
                        }}
                        value={formData?.destinationCloseTime || ''}
                        onChange={e => {
                          handleChange(
                            '',
                            'destinationCloseTime',
                            e.target.value
                          );
                        }}
                        type='time'
                        fullWidth
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>

              {/* Line Item */}
              <Grid item xs={12} mt={2}>
                <Typography fontWeight={500}>Line Item</Typography>
              </Grid>
              <Grid item xs={12}>
                {viewShipmentsDetails.map((details, index) => (
                  <TextField
                    sx={{ mb: 2 }}
                    size='small'
                    fullWidth
                    label={`Item Description ${index + 1}`}
                    value={details.itemDescription}
                    onChange={e => {
                      const updatedDetails = viewShipmentsDetails.map(
                        (item, i) =>
                          i === index
                            ? { ...item, itemDescription: e.target.value }
                            : item
                      );

                      setViewShipmentsDetails(updatedDetails);
                    }}
                  />
                ))}
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => {
                setFormData({});
                props?.handleCloseBolDialog(false);
              }}
            >
              Cancel
            </Button>
            {bolLoader ? (
              <Box
                sx={{
                  minWidth: 90,
                  display: 'flex',
                  justifyContent: 'center'
                }}
              >
                <CircularProgress size={23} color='info' />
              </Box>
            ) : (
              <Button onClick={handleSave} variant='contained' color='primary'>
                Confirm
              </Button>
            )}
          </DialogActions>
        </Dialog>

        {/* Labels Dialog Box */}
        <Dialog
          fullWidth
          maxWidth='md'
          minWidth='xs'
          sx={
            isMobile
              ? {
                  '& .MuiDialog-paper': {
                    overflow: 'hidden',
                    minWidth: '3.6in',
                    maxWidth: '3.6in',
                    height: '90vh'
                  }
                }
              : {
                  '& .MuiDialog-paper': {
                    overflow: 'hidden',
                    minWidth: '4.2in',
                    maxWidth: '4.2in',
                    height: '90vh'
                  }
                }
          }
          // sx={{ minWidth: 80, minHeight: '10vh', height: '90vh' }}
          open={openLabelsDialog}
          onClose={hanldeCloseLabels}
          aria-labelledby='alert-dialog-title'
          aria-describedby='alert-dialog-description'
        >
          <DialogTitle id='alert-dialog-title'>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <div>{openPrintPDfDialogData.carrierName} labels</div>
              <div>
                <CloseIcon
                  sx={{ cursor: 'pointer' }}
                  onClick={hanldeCloseLabels}
                />
              </div>
            </div>
          </DialogTitle>
          <DialogContent>
            <DialogContentText
              sx={{ display: 'flex', justifyContent: 'center' }}
              id='alert-dialog-description'
            >
              <PackagingSlip
                contentRef={contentRef}
                rowData={rowData}
                isMobile={isMobile}
                numberOfPrints={numberOfPrints}
                openPrintPDfDialogData={openPrintPDfDialogData}
                numberOfPrintsColmnVise={numberOfPrintsColmnVise}
              />
            </DialogContentText>
          </DialogContent>
          <DialogActions
            sx={{
              // position: 'sticky',
              // bottom: 0,
              // marginTop: 10,
              // backgroundColor: 'white', // Ensure it doesn’t overlap content
              // zIndex: 1,
              display: 'flex',
              justifyContent: 'space-between'
              // padding: 2
            }}
          >
            <div>
              <label style={{ fontSize: '13' }} htmlFor='printSelect'>
                Number of Prints:
              </label>
              <select
                className='mx-1'
                id='printSelect'
                value={selectedPrintOption}
                onChange={e => {
                  handleChangeNoOfPrints(e);
                }}
              >
                <option value={1}>1</option>
                <option value={2}>2</option>
                <option value={4}>4</option>
                <option value={6}>6</option>
              </select>
            </div>
            <Button
              size='small'
              variant='contained'
              onClick={() =>
                generatePDF(
                  openPrintPDfDialogData.carrierName,
                  50,
                  750,
                  'labels'
                )
              }
            >
              Generate PDF
            </Button>
            <Button
              size='small'
              variant='contained'
              onClick={() => handlePrint()} // Trigger print on click
            >
              Print
            </Button>
          </DialogActions>
        </Dialog>
        {/* BOL Dialog Box */}
        <Dialog
          fullScreen={isMobile}
          fullWidth
          maxWidth='lg'
          open={openPrintPDfDialog}
          onClose={handlePDFPrintClose}
          aria-labelledby='alert-dialog-title'
          aria-describedby='alert-dialog-description'
        >
          <DialogTitle id='alert-dialog-title'>
            <div style={{ display: 'flex', justifyContent: 'end' }}>
              {/* <div>BILL OF LADING </div> */}
              <div>
                <CloseIcon
                  sx={{ cursor: 'pointer' }}
                  onClick={handlePDFPrintClose}
                />
              </div>
            </div>
          </DialogTitle>
          <DialogContent>
            <DialogContentText ref={contentRef} id='alert-dialog-description'>
              <div
                id='pdf-content'
                style={{
                  minWidth: '100%',
                  minHeight: '100%'
                }}
              >
                <BillOfLading
                  rowData={viewShipmentsDetails}
                  rowData2={rowData}
                />
              </div>
            </DialogContentText>
          </DialogContent>
          <DialogActions sx={{ display: 'flex', justifyContent: 'center' }}>
            <Button
              size='small'
              variant='contained'
              onClick={() => generatePDF(rowData.carrierName, 850, 1250, 'bol')}
            >
              Generate PDF
            </Button>
            <Button
              onClick={() => handleUpdateBOLDialog(rowData)}
              color='warning'
              size='small'
              variant='contained'
            >
              Update BOL
            </Button>
          </DialogActions>
        </Dialog>
        {/* Packaging Slip Box */}
        <Dialog
          fullWidth
          maxWidth='md'
          minWidth='xs'
          sx={{ '& .MuiDialog-paper': { minWidth: '850px' } }}
          open={openPDfPackagingSlip}
          onClose={handlePdfPackagingClose}
          aria-labelledby='alert-dialog-title'
          aria-describedby='alert-dialog-description'
        >
          <DialogTitle id='alert-dialog-title'>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <div>Packaging Slip </div>
              <div>
                <CloseIcon
                  sx={{ cursor: 'pointer' }}
                  onClick={handlePdfPackagingClose}
                />
              </div>
            </div>
          </DialogTitle>
          <DialogContent>
            <DialogContentText id='alert-dialog-description'>
              <div
                id='pdf-content'
                style={{
                  minWidth: '100%',
                  minHeight: '100%',
                  padding: 10
                }}
              >
                {/* 1st page  */}
                <div style={{ display: 'flex' }}> </div>
                <div>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between'
                      // alignItems: 'center'
                    }}
                  >
                    <div style={{ margin: -20 }}>
                      <img
                        alt=''
                        style={{ height: 120 }}
                        src={base_logo_url + AgencyAdminDetails?.userAvatar}
                      />
                    </div>
                    <div>
                      <Barcode
                        textPosition='top'
                        displayValue={true}
                        height={50}
                        fontSize={17}
                        width={1.5}
                        value={`Order # ${rowData?.pickupNumber}`}
                      />
                    </div>
                  </div>
                  <div
                    style={{
                      marginTop: -5,
                      display: 'flex',
                      justifyContent: 'flex-end'
                    }}
                  >
                    <div>{rowData.actualPickupDate}</div>
                  </div>
                </div>
                <div
                  style={{
                    display: 'flex',
                    width: '100%'
                  }}
                >
                  <div
                    style={{
                      padding: 10,
                      border: '0.5px solid black',
                      width: '100%'
                    }}
                  >
                    <div style={{ fontWeight: 'bold', fontSize: 18 }}>
                      Consignee/Ship To
                    </div>{' '}
                    <div style={{ marginLeft: 1 }}>
                      <div>{rowData?.originCompany}</div>
                      <div>{rowData?.originAddress}</div>
                      <div>
                        {rowData?.originContactPerson},{' '}
                        {rowData?.originZipCode +
                          ' ' +
                          rowData?.originCity +
                          ' ' +
                          rowData?.originState}
                      </div>
                    </div>
                  </div>
                  <div
                    style={{
                      padding: 10,
                      border: '0.5px solid black',
                      width: '100%'
                    }}
                  >
                    <div style={{ fontWeight: 'bold', fontSize: 18 }}>
                      Sold To
                    </div>{' '}
                    <div style={{ marginLeft: 1 }}>
                      <div>{rowData?.destinationCompany}</div>

                      <div>{rowData?.destinationAddress}</div>
                      <div>
                        {rowData?.destinationContactPerson},
                        {rowData?.destinationZipCode +
                          ' ' +
                          rowData?.destinationCity +
                          ' ' +
                          rowData?.destinationState}
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  <table style={{ marginTop: 10 }} className='custom-table'>
                    <thead
                      style={{
                        backgroundColor: 'rgb(222 222 222)',
                        fontWeight: 'bold',
                        border: 'none'
                      }}
                    >
                      <tr>
                        <th className='custom-col-100'>PO Number</th>
                        <th className='custom-col-100'>Terms</th>
                        <th className='custom-col-100'>Loc</th>
                        <th className='custom-col-100'>Ship Date</th>
                        <th className='custom-col-100'>Freight Terms</th>
                        <th className='custom-col-100'>Carrier</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>{rowData?.clientPONumber}</td>
                        <td> </td>
                        <td>{rowData?.locationName}</td>
                        <td>{rowData.actualPickupDate}</td>
                        <td>{rowData?.freightTerms}</td>
                        <td>{rowData?.carrierName}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div>
                  <table style={{ marginTop: 10 }} className='custom-table'>
                    <thead
                      style={{
                        backgroundColor: 'rgb(222 222 222)',
                        fontWeight: 'bold',
                        border: 'none'
                      }}
                    >
                      <tr>
                        <th className='custom-col-100'>Customer Item</th>
                        <th className='custom-col-100'>Description</th>
                        <th className='custom-col-100'>Qty</th>
                        <th className='custom-col-100'>Class</th>
                      </tr>
                    </thead>
                    <tbody>
                      {viewShipmentsDetails.map(data => (
                        <tr>
                          <td>{data.customerId}</td>
                          <td>
                            {data.itemDescription} <br />
                            <div
                              style={{
                                display: 'flex',
                                justifyContent: 'space-between'
                              }}
                            >
                              <div>
                                <u>Batch</u> <br /> {data.itemNumber}
                              </div>
                              <div>
                                <u>Quantity</u> <br /> {data.netWeight}
                              </div>
                              <div>
                                <u>Nbr of Boxes</u> <br /> {data.pieces}
                              </div>
                              <div>
                                <u>Quantity Per</u> <br />
                              </div>
                            </div>
                          </td>
                          <td>{data.netWeight} LB</td>
                          <td>
                            {`FRT Class ${data.freightClass}` +
                              ' ' +
                              `NMFC ${data.nmfc}`}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                <div className='page-break'></div>
                <div>
                  <div
                    style={{
                      display: 'flex',
                      width: '100%'
                    }}
                  >
                    <div
                      style={{
                        padding: 10,
                        border: '0.5px solid black',
                        width: '100%'
                      }}
                    >
                      <div>
                        This is to certify that the above named materials are
                        properly classified, described, packaged, marked and
                        labeled and are proper condition for transsportation
                        according to the applicable regulations of the
                        Department of Transportation.
                      </div>
                    </div>
                    <div
                      style={{
                        padding: 10,
                        border: '0.5px solid black',
                        width: '100%'
                      }}
                    >
                      <div>
                        If the shipment moves between two port carriers by
                        water, the law requires that the lading shall state
                        whether it is a "carrier shipper's weight." Note: Where
                        the rate is dependent on weight shippers are required to
                        state specifications writing the agreed or declared
                        value of property. The agreed or declared value of the
                        property hereby specifically states by the shipped to be
                        not exceeding ______________.
                      </div>
                    </div>
                  </div>
                  <div
                    style={{
                      padding: 10,
                      border: '0.5px solid black',
                      width: '100%'
                    }}
                  >
                    <div>
                      SUBJECT TO SECTION 7 OF THE CONDITIONS OF APPLICABLE BILL
                      OF LADING, IF THE SHIPMENT IS TO BE DELIVERED TO THE
                      CONSIGNEE, WITHOUT RECOURSE ON THE CONSIGNOR, THE
                      CONSIGNOR SHALL SIGN THE FOLLOWING STATEMENT. THE CARRIER
                      SHALL NOT MAKE DELIVERY OF THIS SHIPMENT WITHOUT PAYMENT
                      OF FREIGHT AND ALL OTHER LAWFUL CHARGES. (Signature)
                      ____________________________.
                    </div>
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      width: '100%'
                    }}
                  >
                    <div
                      style={{
                        padding: 10,
                        border: '0.5px solid black',
                        width: '100%'
                      }}
                    >
                      SHIPPER
                    </div>
                    <div
                      style={{
                        padding: 10,
                        border: '0.5px solid black',
                        width: '100%'
                      }}
                    >
                      AGENT
                    </div>
                  </div>
                </div>
              </div>
            </DialogContentText>
          </DialogContent>
          <DialogActions sx={{ display: 'flex', justifyContent: 'center' }}>
            <Button
              size='small'
              variant='contained'
              onClick={generatePackagingSlipPdf}
            >
              Generate PDF
            </Button>
          </DialogActions>
        </Dialog>
        <Tabs
          orientation='vertical'
          variant='scrollable'
          value={valueY}
          onChange={handleChangeY}
          aria-label='Vertical tabs example'
          sx={{
            borderRight: 1,
            borderColor: 'divider',
            mr: 1
          }}
        >
          <Tab
            sx={{ display: 'flex', alignItems: 'flex-start' }}
            label='Shipment Info'
            {...a11yProps(0)}
          />

          <Tab
            sx={{ display: 'flex', alignItems: 'flex-start' }}
            label='Line Items'
            {...a11yProps(1)}
          />

          <Tab
            sx={{ display: 'flex', alignItems: 'flex-start' }}
            label='Addresses'
            {...a11yProps(2)}
          />
          {/* {(shipmentStatus === 'InTransit' ||
            shipmentStatus === 'Delivered' ||
            shipmentStatus === 'Booked') &&
            rowData?.shipmentType !== 'TL' && (
              <Tab
                sx={{ display: 'flex', alignItems: 'flex-start' }}
                label='Pricing'
                {...a11yProps(3)}
              />
            )} */}
          {(shipmentStatus === 'InTransit' ||
            shipmentStatus === 'Delivered' ||
            (rowData?.proNumber && shipmentStatus === 'Booked')) &&
            rowData?.shipmentType !== 'TL' && (
              <Tab
                sx={{ display: 'flex', alignItems: 'flex-start' }}
                label={
                  loader ? (
                    <CircularProgress sx={{ marginLeft: 8 }} size={22} />
                  ) : (
                    'Delivery Status'
                  )
                }
                {...a11yProps(3)}
                onClick={e =>
                  handleTrackShipmentRequest(props?.rowData, e, 'track')
                }
              />
            )}

          {(shipmentStatus === 'InTransit' || shipmentStatus === 'Delivered') &&
            rowData?.shipmentType === 'TL' && (
              <Tab
                sx={{ textAlign: 'right' }}
                label='Corresponding History'
                {...a11yProps(4)}
                onClick={() => setTLCoressPDrawer(true)}
              />
            )}
          {shipmentStatus !== 'Saved' &&
            shipmentStatus !== 'Tendered' &&
            rowData?.shipmentType !== 'TL' && (
              <Tab sx={{ textAlign: 'right' }} label='Shipment Analysis ' />
            )}

          {claimDetailsAllowed &&
            (shipmentStatus === 'Delivered' ||
              shipmentStatus === 'InTransit') &&
            rowData?.shipmentType !== 'TL' &&
            rowData?.claimStatus !== '' && (
              <Tab
                sx={{ display: 'flex', alignItems: 'flex-start' }}
                onClick={() => getCliamDetails()}
                {...a11yProps(6)}
                label='Claim Details'
              />
            )}

          {shipmentStatus === 'Booked' &&
            props?.rowData?.shipmentType !== 'TL' && (
              <>
                <Button
                  onClick={() => printData(props?.rowData)}
                  sx={{ mt: 2, mr: 1, width: 170 }}
                  size='small'
                  variant='outlined'
                >
                  Print Lables
                </Button>
              </>
            )}
          {shipmentStatus === 'Delivered' &&
            props?.rowData?.shipmentType === 'LTL' && (
              <Button
                sx={{ mt: 2, mr: 1, width: 170 }}
                size='small'
                variant='outlined'
                onClick={() => handleProofOfDeliveryRequest('')}
              >
                {PodDocLoader ? (
                  <CircularProgress size={22} />
                ) : (
                  <>
                    Proof of Delivery
                    <DownloadIcon sx={{ fontSize: 18 }} />
                  </>
                )}
              </Button>
            )}
          {(shipmentStatus === 'InTransit' ||
            shipmentStatus === 'Delivered' ||
            shipmentStatus === 'Booked') &&
            props?.rowData?.shipmentType !== 'Parcel' && (
              <Button
                sx={{ mt: 2, mr: 1, width: 170 }}
                size='small'
                variant='outlined'
                onClick={() => setOpenPrintPDfDialog(true)}
              >
                Bill of Lading
                <DownloadIcon sx={{ fontSize: 18 }} />
              </Button>
            )}
        </Tabs>
        <TabPanel value={valueY} index={0}>
          <Box sx={{ bgcolor: 'background.paper', width: '90vw' }}>
            <TabPanelX value={valueX} index={0}>
              <Row>
                {
                  <Col lg={3} xl={3}>
                    <div style={{ marginTop: 10 }}>
                      <div className='View_Details_Headings'>Shipment #</div>
                      <span className='View_Details'>{rowData.soNumber}</span>
                    </div>

                    {(shipmentStatus === 'InTransit' ||
                      shipmentStatus === 'Delivered' ||
                      shipmentStatus === 'Booked') &&
                    rowData.shipmentType === 'TL' ? (
                      <div style={{ marginTop: 10 }}>
                        <div className='View_Details_Headings'>
                          Service Type
                        </div>
                        <span className='View_Details'>
                          {rowData.pickupNumber}
                        </span>
                      </div>
                    ) : (
                      (shipmentStatus === 'InTransit' ||
                        shipmentStatus === 'Delivered' ||
                        shipmentStatus === 'Delivered' ||
                        shipmentStatus === 'Booked') && (
                        <div style={{ marginTop: 10 }}>
                          <div className='View_Details_Headings'>
                            Pickup Request Number
                          </div>

                          <span className='View_Details'>
                            {' '}
                            {rowData.pickupNumber}
                          </span>
                        </div>
                      )
                    )}
                  </Col>
                }

                {(shipmentStatus === 'InTransit' ||
                  shipmentStatus === 'Delivered' ||
                  shipmentStatus === 'Booked') &&
                rowData.shipmentType === 'Parcel' ? (
                  <Col lg={3} xl={3}>
                    <div style={{ marginTop: 10 }}>
                      <div className='View_Details_Headings'>Tracking#</div>
                      <span className='View_Details'> {rowData.proNumber}</span>
                    </div>
                  </Col>
                ) : (
                  (shipmentStatus === 'InTransit' ||
                    shipmentStatus === 'Delivered' ||
                    shipmentStatus === 'Booked') &&
                  rowData.shipmentType !== 'TL' &&
                  (rowData.proNumber || rowData.bolNumber) && (
                    <Col lg={3} xl={3}>
                      {rowData.proNumber && (
                        <div style={{ marginTop: 10 }}>
                          <div className='View_Details_Headings'>PRO# </div>
                          <span className='View_Details'>
                            {' '}
                            {rowData.proNumber}
                          </span>
                        </div>
                      )}

                      {(rowData.bolNumber || rowData?.quoteNumber) && (
                        <div style={{ marginTop: 10 }}>
                          <div className='View_Details_Headings'>BOL#</div>
                          <span className='View_Details'>
                            {rowData?.shipmentType === 'TL'
                              ? rowData?.quoteNumber
                              : rowData.bolNumber}
                          </span>
                        </div>
                      )}
                    </Col>
                  )
                )}

                <Col lg={3} xl={3}>
                  {rowData.quoteNumber && rowData.shipmentType !== 'Parcel' && (
                    <div style={{ marginTop: 10, whiteSpace: 'nowrap' }}>
                      <div className='View_Details_Headings'>
                        Reference/Quote
                      </div>

                      {rowData.quoteNumber}
                    </div>
                  )}
                  <div style={{ marginTop: 10 }}>
                    <div className='View_Details_Headings'>Purchase Order#</div>

                    <span className='View_Details'>
                      {' '}
                      {rowData.clientPONumber}
                    </span>
                  </div>
                </Col>

                <Col lg={3} xl={3}>
                  <div
                    style={
                      rowData.quoteNumber ? { marginTop: 10 } : { marginTop: 1 }
                    }
                  >
                    <div className='View_Details_Headings'> Location Name</div>

                    <div className='View_Details'>{rowData.locationName}</div>
                    {rowData.shipmentMiles ? (
                      <>
                        <div
                          style={{ marginTop: 10 }}
                          className='View_Details_Headings'
                        >
                          {' '}
                          Shipment Distance
                        </div>
                        <div className='View_Details'>
                          {/* {convertMetersToMiles(rowData.shipmentMiles).toFixed(2)}{' '} */}
                          {rowData.shipmentMiles} miles
                        </div>
                      </>
                    ) : null}
                  </div>
                </Col>

                {rowData.shipmentType === 'TL' && (
                  <Col lg={3} xl={3}>
                    <div style={{ marginTop: 10, whiteSpace: 'nowrap' }}>
                      <div className='View_Details_Headings'>MC #</div>

                      {rowData.motorCarrierNumber}
                    </div>
                    <div style={{ marginTop: 10 }}>
                      <div className='View_Details_Headings'>
                        Truck/ Trailer#
                      </div>

                      <span className='View_Details'>
                        {' '}
                        {rowData.trailerNumber}
                      </span>
                    </div>
                  </Col>
                )}
              </Row>
            </TabPanelX>
          </Box>
        </TabPanel>

        <TabPanel value={valueY} index={1}>
          <Box>
            <TabPanelX value={valueX} index={0}>
              <Row>
                <Col lg={12} xl={12}>
                  <TableContainer sx={{ width: '70vw' }} component={Paper}>
                    <Table
                      sx={{ width: '70vw' }}
                      // size='small'
                      // aria-label='a dense table'
                    >
                      <TableHead>
                        <TableRow>
                          {rowData?.shipmentType === 'TL' && (
                            <TableCell sx={{ fontWeight: 'bold' }} align='left'>
                              Item type
                            </TableCell>
                          )}
                          <TableCell sx={{ fontWeight: 'bold' }} align='left'>
                            Unit Type
                          </TableCell>
                          <>
                            <TableCell sx={{ fontWeight: 'bold' }} align='left'>
                              # of Units
                            </TableCell>
                            {rowData?.shipmentType !== 'TL' && (
                              <TableCell
                                sx={{ fontWeight: 'bold' }}
                                align='left'
                              >
                                # of Pieces
                              </TableCell>
                            )}
                          </>
                          <TableCell sx={{ fontWeight: 'bold' }} align='left'>
                            NMFC
                          </TableCell>

                          {rowData?.shipmentType !== 'Parcel' && (
                            <TableCell sx={{ fontWeight: 'bold' }} align='left'>
                              Freight Class
                            </TableCell>
                          )}
                          <TableCell sx={{ fontWeight: 'bold' }} align='left'>
                            {rowData?.shipmentType === 'TL'
                              ? 'Net Weight'
                              : 'Weight'}{' '}
                            (lbs)
                          </TableCell>
                          {rowData?.shipmentType === 'TL' && (
                            <TableCell sx={{ fontWeight: 'bold' }} align='left'>
                              Gross Weight (lbs)
                            </TableCell>
                          )}

                          {/* <TableCell sx={{ fontWeight: 'bold' }} align='left'>
                            NMFC
                          </TableCell> */}
                          <TableCell sx={{ fontWeight: 'bold' }} align='left'>
                            Dimensions (L W H)
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {viewShipmentsDetails.map(row => (
                          <TableRow
                            key={row.name}
                            // sx={{
                            //   '&:last-child td, &:last-child th': { border: 0 }
                            // }}
                          >
                            {rowData?.shipmentType === 'TL' && (
                              <TableCell align='left'>{row.itemType}</TableCell>
                            )}
                            <TableCell align='left'>
                              {row.packagingType}
                            </TableCell>
                            <TableCell align='left'>{row.units}</TableCell>
                            {rowData?.shipmentType !== 'TL' && (
                              <>
                                <TableCell align='left'>{row.pieces}</TableCell>
                              </>
                            )}
                            <TableCell align='left'>
                              {rowData?.shipmentType === 'TL' ? ' ' : row.nmfc}
                            </TableCell>

                            {rowData?.shipmentType !== 'Parcel' &&
                            row.itemType !== 'Delivery' ? (
                              <TableCell align='left'>
                                {row.freightClass}
                              </TableCell>
                            ) : (
                              <TableCell></TableCell>
                            )}
                            {row.itemType !== 'Delivery' ? (
                              <TableCell align='left'>
                                {row.netWeight}
                              </TableCell>
                            ) : (
                              <TableCell></TableCell>
                            )}
                            {rowData?.shipmentType === 'TL' && (
                              <TableCell align='left'>
                                {row.grossWeight}
                              </TableCell>
                            )}
                            {row.itemType !== 'Delivery' ? (
                              <TableCell align='left'>
                                {row.length} x {row.width} x {row.height}
                              </TableCell>
                            ) : (
                              <TableCell></TableCell>
                            )}
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Col>
              </Row>
            </TabPanelX>
          </Box>
        </TabPanel>

        <TabPanel value={valueY} index={2}>
          <TabPanelX value={valueX} index={0}>
            <Row>
              <Col lg={12} xl={12}>
                <TableContainer sx={{ width: '70vw' }} component={Paper}>
                  <Table
                    sx={{ width: '70vw' }}
                    // size='small'
                    // aria-label='a dense table'
                  >
                    <TableHead>
                      <TableRow>
                        {/* <TableCell sx={{ fontWeight: 'bold' }}>
                          Lables
                        </TableCell> */}
                        <TableCell sx={{ fontWeight: 'bold' }}>
                          Origin Information
                        </TableCell>
                        <TableCell sx={{ fontWeight: 'bold' }} align='left'>
                          Destination Information
                        </TableCell>
                        <TableCell sx={{ fontWeight: 'bold' }} align='left'>
                          Bill To Information
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {(rowData.originCompany ||
                        rowData.destinationCompany ||
                        rowData.billToCompany) && (
                        <TableRow
                          sx={{
                            '&:last-child td, &:last-child th': { border: 0 }
                          }}
                        >
                          {/* <TableCell component='th' scope='row'>
                            <b>Company Name</b>
                          </TableCell> */}
                          <TableCell align='left'>
                            {rowData.originCompany}
                          </TableCell>
                          <TableCell align='left'>
                            {rowData.destinationCompany}
                          </TableCell>
                          <TableCell align='left'>
                            {rowData.billToCompany}
                          </TableCell>
                        </TableRow>
                      )}

                      {(rowData.originAddress ||
                        rowData.destinationAddress ||
                        rowData.billToAddress) && (
                        <TableRow
                          sx={{
                            '&:last-child td, &:last-child th': { border: 0 }
                          }}
                        >
                          <TableCell align='left'>
                            {rowData.originAddress}{' '}
                            {rowData.originAddress2 &&
                              `, ${rowData.originAddress2}`}
                          </TableCell>
                          <TableCell align='left'>
                            {rowData.destinationAddress}{' '}
                            {rowData.destinationAddress2 &&
                              `, ${rowData.destinationAddress2}`}
                          </TableCell>
                          <TableCell align='left'>
                            {rowData.billToAddress}{' '}
                            {rowData.billToAddress2 &&
                              `, ${rowData.billToAddress2}`}
                          </TableCell>
                        </TableRow>
                      )}

                      <TableRow
                        sx={{
                          '&:last-child td, &:last-child th': { border: 0 }
                        }}
                      >
                        <TableCell align='left'>
                          {rowData.originZipCode +
                            ', ' +
                            rowData.originCity +
                            ', ' +
                            rowData.originState}
                        </TableCell>

                        <TableCell align='left'>
                          {rowData.destinationZipCode +
                            ', ' +
                            rowData.destinationCity +
                            ', ' +
                            rowData.destinationState}
                        </TableCell>
                        <TableCell align='left'>
                          {rowData.billToZipCode &&
                            rowData.billToZipCode +
                              ', ' +
                              rowData.billToCity +
                              ', ' +
                              rowData.billToState}
                        </TableCell>
                      </TableRow>

                      {/* Phone Row */}
                      {(originDetails?.contactPhone ||
                        destinationDetails?.contactPhone ||
                        rowData.originContactPhone ||
                        rowData.destinationContactPhone) && (
                        <TableRow
                          sx={{
                            '&:last-child td, &:last-child th': { border: 0 }
                          }}
                        >
                          <TableCell align='left'>
                            {formatPhoneNumber(
                              originDetails?.contactPhone ||
                                rowData.originContactPhone
                            )}
                          </TableCell>
                          <TableCell align='left'>
                            {formatPhoneNumber(
                              destinationDetails?.contactPhone ||
                                rowData.destinationContactPhone
                            )}
                          </TableCell>
                          <TableCell align='left'>
                            {formatPhoneNumber(rowData.billToContactPhone)}
                          </TableCell>
                        </TableRow>
                      )}

                      {/* Email Row */}
                      {(originDetails?.contactEmail ||
                        destinationDetails?.contactEmail ||
                        rowData.originContactEmail ||
                        rowData.destinationContactEmail) && (
                        <TableRow
                          sx={{
                            '&:last-child td, &:last-child th': { border: 0 }
                          }}
                        >
                          <TableCell align='left'>
                            {originDetails?.contactEmail ||
                              rowData.originContactEmail}
                          </TableCell>
                          <TableCell align='left'>
                            {destinationDetails?.contactEmail ||
                              rowData.destinationContactEmail}
                          </TableCell>
                          <TableCell align='left'>
                            {rowData.billToContactEmail}
                          </TableCell>
                        </TableRow>
                      )}
                      {/* )} */}
                      <TableRow
                        sx={{
                          '&:last-child td, &:last-child th': { border: 0 }
                        }}
                      >
                        <TableCell align='left'>
                          <b>
                            {shipmentStatus === 'InTransit' ||
                            shipmentStatus === 'Delivered'
                              ? 'Actual Pickup Date'
                              : 'Requested Pickup Date'}{' '}
                            :
                          </b>{' '}
                          {shipmentStatus === 'InTransit' ||
                          shipmentStatus === 'Delivered'
                            ? rowData.actualPickupDate
                            : rowData.pickupDate}
                        </TableCell>
                        <TableCell align='left'>
                          <b>
                            {shipmentStatus === 'Delivered'
                              ? 'Actual Delivery Date'
                              : 'Est. Delivery Date'}{' '}
                            :
                          </b>{' '}
                          {shipmentStatus === 'Delivered'
                            ? rowData.actualDeliveryDate
                            : rowData.deliveryDate}
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </Col>
            </Row>
          </TabPanelX>
        </TabPanel>
        {/* Surcharge Details  */}
        {/* {(shipmentStatus === 'InTransit' ||
          shipmentStatus === 'Delivered' ||
          shipmentStatus === 'Booked') &&
          rowData?.shipmentType !== 'TL' && (
            <TabPanel value={valueY} index={3}>
              <TabPanelX value={valueX} index={0}>
                <Row>
                  <Col lg={12} xl={12}>
                    <TableContainer sx={{ width: '70vw' }} component={Paper}>
                      <Table sx={{ width: '70vw' }}>
                        <TableHead>
                          <TableRow>
                            <TableCell sx={{ fontWeight: 'bold' }}>
                              Base Charges Detail
                            </TableCell>
                            <TableCell sx={{ fontWeight: 'bold' }}>
                              Charges
                            </TableCell>
                            {rowData?.surchargesList.some(s =>
                              accessorialDescriptions.includes(s.description)
                            ) ? (
                              <>
                                <TableCell sx={{ fontWeight: 'bold' }}>
                                  Accessorial Charges Detail
                                </TableCell>
                                <TableCell sx={{ fontWeight: 'bold' }}>
                                  Charges
                                </TableCell>
                              </>
                            ) : (
                              <>
                                <TableCell align='left'></TableCell>
                                <TableCell align='left'></TableCell>
                              </>
                            )}
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {[...Array(maxLength)].map((_, index) => {
                            const main = mainCharges[index];
                            const accessorial = accessorialCharges[index];

                            return (
                              <TableRow key={index}>
                                <TableCell align='left'>
                                  {main?.description || ''}
                                </TableCell>
                                <TableCell align='left'>
                                  {main
                                    ? main.description.includes('%')
                                      ? `${main.amount?.amount.toFixed(2)}%`
                                      : formatePrice(main.amount?.amount)
                                    : ''}
                                </TableCell>

                                <TableCell align='left'>
                                  {accessorial?.description || ''}
                                </TableCell>
                                <TableCell align='left'>
                                  {accessorial
                                    ? accessorial.description.includes('%')
                                      ? `${accessorial.amount?.amount.toFixed(
                                          2
                                        )}%`
                                      : formatePrice(accessorial.amount?.amount)
                                    : ''}
                                </TableCell>
                              </TableRow>
                            );
                          })}
                          <TableRow
                            sx={{
                              '&:last-child td, &:last-child th': { border: 0 }
                            }}
                          >
                            <TableCell sx={{ fontWeight: 'bold' }}>
                              {rowData?.surchargesList.some(s =>
                                accessorialDescriptions.includes(s.description)
                              )
                                ? 'Total Base Charge'
                                : 'Total Net Charge'}
                            </TableCell>
                            <TableCell sx={{ fontWeight: 'bold' }}>
                              $
                              {rowData?.surchargesList
                                ?.sort(applySubChargesSort)
                                .filter(s =>
                                  baseRateDescrptions.includes(s.description)
                                )
                                .reduce(
                                  (total, s) => total + (s.amount?.amount || 0),
                                  0
                                )
                                .toFixed(2)}
                            </TableCell>

                            {rowData?.surchargesList.some(s =>
                              accessorialDescriptions.includes(s.description)
                            ) && (
                              <>
                                <TableCell sx={{ fontWeight: 'bold' }}>
                                  Total Accessorial Charge
                                </TableCell>
                                <TableCell sx={{ fontWeight: 'bold' }}>
                                  $
                                  {rowData?.surchargesList
                                    ?.sort(applySubChargesSort)
                                    .filter(s =>
                                      accessorialDescriptions.includes(
                                        s.description
                                      )
                                    )
                                    .reduce(
                                      (total, s) =>
                                        total + (s.amount?.amount || 0),
                                      0
                                    )
                                    .toFixed(2)}
                                </TableCell>
                              </>
                            )}
                          </TableRow>
                          {rowData?.surchargesList.some(s =>
                            accessorialDescriptions.includes(s.description)
                          ) && (
                            <TableRow
                              sx={{
                                '&:last-child td, &:last-child th': {
                                  border: 0
                                }
                              }}
                            >
                              <TableCell sx={{ fontWeight: 'bold' }}>
                                Total Net Charge
                              </TableCell>
                              <TableCell sx={{ fontWeight: 'bold' }}>
                                ${rowData?.shipmentCharges?.toFixed(2)}
                              </TableCell>
                            </TableRow>
                          )}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Col>
                </Row>
              </TabPanelX>
            </TabPanel>
          )} */}

        {shipmentStatus !== 'Booked' && (
          <TabPanel value={valueY} index={3}>
            <TabPanelX value={valueX} index={0}>
              {rowData?.shipmentType === 'TL' ? (
                (shipmentStatus === 'InTransit' ||
                  shipmentStatus === 'Delivered') && (
                  <div>
                    <Drawer
                      anchor='right'
                      open={TLCoressPDrawer}
                      onClose={handleCloaseTLCoressPDrawer}
                    >
                      <div className='d-flex flex-column justify-content-center h-100'>
                        {!docLoader ? (
                          historyError ? (
                            <Box
                              sx={{ textAlign: 'center' }}
                              className='Chat_Child_View_Shipment'
                            >
                              <br />
                              <br />
                              <br />
                              <br />
                              <WarningAmberIcon
                                style={{ fontSize: 150, color: '#D32F2F' }}
                              />{' '}
                              {/* <br /> */}
                              <br />
                              <Typography variant='h5'>
                                No history found for this shipment!
                              </Typography>
                              <br />
                              <br />
                              <br />
                            </Box>
                          ) : (
                            <div className='Chat_Child_View_Shipment py-2 pt-4 h-100'>
                              {shipperApiMsgs &&
                                shipperApiMsgs.map(carrierRes => (
                                  <div
                                    style={
                                      carrierRes.actionByFlag.toLowerCase() ===
                                      'carrier'
                                        ? {
                                            display: 'flex',
                                            justifyContent: 'start',
                                            flexDirection: 'column',
                                            marginLeft: 10,
                                            marginRight: 10,
                                            width: 400,
                                            position: 'relative'
                                          }
                                        : {
                                            display: 'flex',
                                            justifyContent: 'end',
                                            // flexDirection: 'column',
                                            marginLeft: 10,
                                            marginRight: 10,
                                            position: 'relative'
                                          }
                                    }
                                  >
                                    {carrierRes.actionByFlag.toLowerCase() ===
                                      'carrier' && (
                                      <div
                                        style={{
                                          display: 'flex',
                                          justifyContent: 'start'
                                        }}
                                      >
                                        <div
                                          style={{
                                            backgroundColor: '#e0f2f1',
                                            borderRadius: '50%',
                                            width: '45',
                                            height: '45',
                                            textAlign: 'center',
                                            display: 'flex',
                                            justifyContent: 'center',
                                            marginRight: 10
                                          }}
                                        >
                                          <img
                                            style={{
                                              borderRadius: '50%',
                                              width: '45',
                                              height: '45',
                                              textAlign: 'center',
                                              display: 'flex',
                                              justifyContent: 'center',
                                              objectFit: 'cover'
                                            }}
                                            alt=''
                                            src={
                                              base_logo_url +
                                              carrierApiMsgs[0]?.actionByImage
                                            }
                                          />
                                        </div>
                                        <div>
                                          <b style={{ fontSize: 18 }}>
                                            {carrierApiMsgs &&
                                              carrierApiMsgs[0]?.actionByName}
                                          </b>
                                          <br />
                                          <span style={{ fontWeight: 600 }}>
                                            {
                                              carrierApiMsgs[0]
                                                ?.actionByDesignation
                                            }
                                          </span>
                                        </div>
                                      </div>
                                    )}
                                    <div>
                                      {carrierRes.actionByFlag.toLowerCase() ===
                                        'shipper' && (
                                        <div
                                          style={{
                                            display: 'flex',
                                            justifyContent: 'end'
                                          }}
                                        >
                                          <div
                                            style={{
                                              marginLeft: 0,
                                              marginRight: 1,
                                              textAlign: 'right'
                                            }}
                                          >
                                            <b style={{ fontSize: 18 }}>
                                              {shipperApiMsgs &&
                                                shipperApiMsgs[0]?.actionByName}
                                            </b>
                                            <br />
                                            <span style={{ fontWeight: 600 }}>
                                              {
                                                shipperApiMsgs[0]
                                                  ?.actionByDesignation
                                              }
                                            </span>
                                            <br />
                                          </div>
                                          <div
                                            style={{
                                              backgroundColor: '#e0f2f1',
                                              borderRadius: '50%',
                                              width: '45',
                                              height: '45',
                                              textAlign: 'center',
                                              display: 'flex',
                                              justifyContent: 'center',
                                              marginLeft: 10
                                            }}
                                          >
                                            <img
                                              style={{
                                                borderRadius: '50%',
                                                width: '45',
                                                height: '45',
                                                textAlign: 'center',
                                                display: 'flex',
                                                justifyContent: 'center',
                                                objectFit: 'cover'
                                              }}
                                              alt=''
                                              src={
                                                base_logo_url +
                                                shipperApiMsgs[0]?.actionByImage
                                              }
                                            />
                                          </div>
                                        </div>
                                      )}
                                      <div
                                        style={
                                          carrierRes.actionByFlag.toLowerCase() ===
                                          'shipper'
                                            ? {
                                                marginBottom: '10vh',
                                                backgroundColor: '#e0f2f1',
                                                borderRadius:
                                                  '10px 0px 10px 10px',
                                                padding: '10px',
                                                transform: '(rotateX(180deg)'
                                              }
                                            : {
                                                marginBottom: '10vh',
                                                backgroundColor: '#eceff1',
                                                padding: '10px',
                                                borderRadius:
                                                  '0px 10px 10px 10px'
                                              }
                                        }
                                      >
                                        <div
                                          style={{ fontSize: 12 }}
                                          dangerouslySetInnerHTML={{
                                            __html: handleCorresHistory(
                                              carrierRes.actionData
                                            )
                                          }}
                                        ></div>
                                        <div
                                          style={{
                                            display: 'flex',
                                            justifyContent: 'flex-end',
                                            fontSize: 11
                                          }}
                                        >
                                          {handleDateTimeShow(
                                            carrierRes.date,
                                            'time'
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                ))}

                              {/* <div ref={bottomRef} /> */}
                            </div>
                          )
                        ) : (
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                              width: '50vw',
                              height: '90%'
                            }}
                          >
                            <CircularProgress />
                          </div>
                        )}
                      </div>
                    </Drawer>
                  </div>
                )
              ) : (
                <Box sx={{ height: '40vh' }}>
                  <Col xl={10} lg={10}>
                    {trackShipmentData && (
                      <div
                        style={{
                          display: 'flex',
                          // justifyContent: 'space-between',
                          // alignItems: 'center',
                          flexDirection: 'column-reverse',
                          // backgroundColor: 'red',
                          width: '100%'
                        }}
                      >
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'start'
                          }}
                        >
                          <TrackShipmentDetails
                            trackShipmentData={trackShipmentData}
                            view={viewType}
                            rowData={rowData}
                          />
                        </div>
                      </div>
                    )}
                  </Col>
                </Box>
              )}
            </TabPanelX>
          </TabPanel>
        )}
        {rowData?.shipmentType !== 'TL' && (
          <TabPanel value={valueY} index={rowData?.proNumber ? 4 : 3}>
            <Box sx={{ bgcolor: 'background.paper', width: '90vw' }}>
              <TabPanelX value={valueX} index={0}>
                <Row>
                  <Col lg={12} xl={12}>
                    <TableContainer sx={{ width: '70vw' }} component={Paper}>
                      <Table
                        sx={{ width: '70vw' }}
                        // size='small'
                        // aria-label='a dense table'
                      >
                        <TableHead>
                          <TableRow>
                            <TableCell sx={{ fontWeight: 'bold' }} align='left'>
                              Labels
                            </TableCell>
                            <TableCell sx={{ fontWeight: 'bold' }}>
                              Lowest Cost Carrier
                            </TableCell>
                            <TableCell sx={{ fontWeight: 'bold' }} align='left'>
                              Booked Carrier
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          <TableRow
                            sx={{
                              textAlign: 'right',
                              '&:last-child td, &:last-child th': { border: 0 }
                            }}
                          >
                            <TableCell align='left'>
                              <b>Carrier Name</b>:
                            </TableCell>
                            <TableCell align='right'>
                              <div
                                className='View_Details'
                                style={
                                  rowData.leastCostCarrierLogo
                                    ? {
                                        marginLeft: -10,
                                        height: 20,
                                        display: 'flex',
                                        alignItems: 'center',
                                        textAlign: 'left',
                                        alignSelf: 'self-start'
                                      }
                                    : {
                                        height: 20,
                                        display: 'flex',
                                        alignItems: 'center',
                                        textAlign: 'left',
                                        alignSelf: 'self-start'
                                      }
                                }
                              >
                                {rowData.leastCostCarrierLogo ? (
                                  <AvatarGroup sx={{ gap: 'small' }}>
                                    <Avatar
                                      sx={{
                                        fontSize: '14px',
                                        width: 40,
                                        height: 40
                                      }}
                                      imgProps={{
                                        style: {
                                          height: 25
                                        }
                                      }}
                                      src={
                                        rowData.leastCostCarrierLogo
                                          ? base_logo_url +
                                            rowData.leastCostCarrierLogo
                                          : NoLogo
                                      }
                                    ></Avatar>
                                  </AvatarGroup>
                                ) : (
                                  'Not Available'
                                )}
                                {rowData.leastCostCarrierName}
                              </div>
                            </TableCell>
                            <TableCell align='right'>
                              <div
                                className='View_Details'
                                style={{
                                  marginLeft: -10,
                                  height: 20,
                                  display: 'flex',
                                  alignItems: 'center',
                                  textAlign: 'left',
                                  alignSelf: 'self-start'
                                }}
                              >
                                <AvatarGroup sx={{ gap: 'small' }}>
                                  <Avatar
                                    sx={{
                                      fontSize: '14px',
                                      width: 40,
                                      height: 40
                                    }}
                                    imgProps={{
                                      style: {
                                        height: 25
                                      }
                                    }}
                                    src={
                                      rowData.carrierLogo
                                        ? base_logo_url + rowData.carrierLogo
                                        : NoLogo
                                    }
                                  ></Avatar>
                                </AvatarGroup>
                                {rowData.carrierName}
                              </div>
                            </TableCell>
                          </TableRow>

                          <TableRow
                            sx={{
                              '&:last-child td, &:last-child th': { border: 0 }
                            }}
                          >
                            <TableCell align='left'>
                              <b>Rate</b>:
                            </TableCell>
                            <TableCell align='left'>
                              <div className='View_Details'>
                                {rowData.leastCost
                                  ? `$${(
                                      rowData.leastCost +
                                      rowData.leastCostAgencySurcharge
                                    ).toFixed(2)}`
                                  : 'Not Available'}
                              </div>
                            </TableCell>
                            <TableCell align='left'>
                              <div className='View_Details'>
                                ${rowData.shipmentCharges}
                              </div>
                            </TableCell>
                          </TableRow>
                          <TableRow
                            sx={{
                              '&:last-child td, &:last-child th': { border: 0 }
                            }}
                          >
                            <TableCell align='left'>
                              <b>Transit Days</b>:
                            </TableCell>
                            <TableCell align='left'>
                              <div className='View_Details'>
                                {rowData.leastTransitDays
                                  ? rowData.leastTransitDays
                                  : 'Not Available'}
                              </div>
                            </TableCell>
                            <TableCell align='left'>
                              <div className='View_Details'>
                                {rowData.estimatedTransitDays}
                              </div>
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Col>
                </Row>
                {/* <Row>
                <Col lg={4} xl={4}>
                  <div style={{ marginTop: 10 }}>
                    <div className='View_Details_Headings'>
                      {' '}
                      Least Cost Carrier Name
                    </div>

                    <div
                      className='View_Details'
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        textAlign: 'left',
                        alignSelf: 'self-start'
                      }}
                    >
                      <AvatarGroup sx={{ gap: 'small' }}>
                        <Avatar
                          sx={{
                            fontSize: '14px',
                            width: 40,
                            height: 40
                          }}
                          imgProps={{
                            style: {
                              height: 25
                            }
                          }}
                          src={
                            rowData.leastCostCarrierLogo
                              ? base_logo_url + rowData.leastCostCarrierLogo
                              : NoLogo
                          }
                        ></Avatar>
                      </AvatarGroup>
                      {rowData.leastCostCarrierName}
                    </div>
                  </div>
                </Col>
                <Col lg={4} xl={4}>
                  <div style={{ marginTop: 10 }}>
                    <div className='View_Details_Headings'>
                      {' '}
                      Least Cost Carrier Rate
                    </div>

                    <div className='View_Details'>${rowData.leastCost}</div>
                  </div>
                </Col>
                <Col lg={4} xl={4}>
                  <div style={{ marginTop: 10 }}>
                    <div className='View_Details_Headings'>
                      {' '}
                      Least Cost Carrier Days
                    </div>

                    <div className='View_Details'>
                      {rowData.leastTransitDays}
                    </div>
                  </div>
                </Col>
              </Row> */}
              </TabPanelX>
            </Box>
          </TabPanel>
        )}
        {rowData?.shipmentType !== 'TL' &&
          (shipmentStatus === 'Delivered' ||
            shipmentStatus === 'InTransit') && (
            <TabPanel value={valueY} index={5}>
              <TabPanelX value={valueX} index={0}>
                <Box
                  sx={{
                    border: '1px solid #ddd',
                    borderRadius: 2,
                    p: 2,
                    mb: 2,
                    // width: '90%',
                    backgroundColor: '#fafafa'
                    // fontSize: '0.75rem'
                  }}
                >
                  <Typography variant='h6' sx={{ fontWeight: 700, mb: 1 }}>
                    Claim #{claimDetails?.claimNumber || 'N/A'}
                  </Typography>
                  <Divider sx={{ mb: 2 }} />

                  <Grid container spacing={2}>
                    {[
                      {
                        label: 'Status',
                        value: claimDetails?.claimStatus
                      },
                      { label: 'Type', value: claimDetails?.claimType },
                      {
                        label: 'Filed Date',
                        value: formatDateUTC(claimDetails?.filedDate)
                      },
                      {
                        label: damagedOrShortageClaim
                          ? 'Quantity Affected'
                          : null,
                        value: damagedOrShortageClaim
                          ? claimDetails?.affectedClaimQuantity
                          : null
                      },
                      {
                        label: 'Claim Amount',
                        value: `$${claimDetails?.claimAmount}`
                      },
                      {
                        label: concealedDamagedClaim
                          ? 'Concealed Damage Details'
                          : null,
                        value: concealedDamagedClaim
                          ? claimDetails?.concealedDamageLoss
                          : null
                      }
                    ]
                      .filter(
                        item => item?.label != null && item?.value != null
                      )
                      .map((item, idx) => (
                        <Grid key={idx} item xs={6} sx={{}}>
                          <Typography
                            variant='subtitle2'
                            sx={{ fontWeight: 600, color: 'text.primary' }}
                          >
                            {item.label}
                          </Typography>
                          <Typography variant='body1' sx={{ fontWeight: 400 }}>
                            {item.label === 'Status' ? (
                              <Grid
                                gap={2}
                                sx={{
                                  display: 'flex',
                                  alignItems: 'center'
                                }}
                              >
                                <Typography
                                  variant='body1'
                                  sx={{
                                    fontWeight: 400,
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 1
                                  }}
                                >
                                  {claimDetails?.claimStatus || 'N/A'}
                                  {getStatusIcon(claimDetails?.claimStatus)}
                                </Typography>
                                {/* <Button
                                  variant='contained'
                                  color='success'
                                  size='small'
                                  onClick={handleSubmitClaim}
                                >
                                  Update Status
                                </Button> */}
                              </Grid>
                            ) : (
                              <Typography
                                variant='body1'
                                sx={{ fontWeight: 400 }}
                              >
                                {item.value}
                              </Typography>
                            )}
                          </Typography>
                        </Grid>
                      ))}

                    {claimDetails.claimType === 'Damage' && (
                      <Grid item xs={12} md={2}>
                        <Typography
                          variant='subtitle2'
                          sx={{ fontWeight: 600, color: 'text.primary' }}
                        >
                          Claim Description
                        </Typography>
                        <Tooltip
                          title={claimDetails?.additionalComments || 'N/A'}
                        >
                          <Typography
                            variant='body2'
                            noWrap
                            sx={{
                              fontWeight: 400,
                              maxWidth: 300,
                              cursor: 'pointer'
                            }}
                          >
                            {claimDetails?.additionalComments || 'N/A'}
                          </Typography>
                        </Tooltip>
                      </Grid>
                    )}
                  </Grid>

                  <Divider sx={{ my: 2 }} />

                  <Typography variant='h6' sx={{ fontWeight: 700 }}>
                    Documents
                  </Typography>

                  {claimDetails?.documents?.length > 0 ? (
                    <Grid container spacing={2} sx={{ mt: 1 }}>
                      {claimDetails.documents.map((doc, idx) => {
                        const fileInfo = getFileTypeInfo(doc);

                        // Extract file extension from name or path
                        const getFileExtension = (fileName, filePath) => {
                          const name = fileName || filePath || '';
                          const extension = name.split('.').pop().toLowerCase();
                          return extension && extension.length <= 5
                            ? `.${extension}`
                            : '';
                        };

                        const fileExtension = getFileExtension(
                          doc.name,
                          doc.filePath
                        );

                        return (
                          <Grid item xs={6} sm={4} md={3} lg={2} key={idx}>
                            <Card
                              sx={{
                                height: 160,
                                border: `1px solid ${fileInfo.color}30`,
                                transition: 'all 0.2s ease',
                                cursor: 'pointer',
                                '&:hover': {
                                  boxShadow: 2,
                                  transform: 'translateY(-1px)'
                                }
                              }}
                              onClick={() =>
                                handleOpenFile(base_logo_url + doc.filePath)
                              }
                            >
                              <CardContent
                                sx={{
                                  display: 'flex',
                                  flexDirection: 'column',
                                  alignItems: 'center',
                                  justifyContent: 'space-between',
                                  height: '100%',
                                  p: 1.5,
                                  backgroundColor: fileInfo.bgColor
                                }}
                              >
                                <Box
                                  sx={{
                                    flex: 1,
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                  }}
                                >
                                  {doc?.fileType?.startsWith('image/') &&
                                  doc.filePath ? (
                                    <Box
                                      sx={{
                                        width: 60,
                                        height: 60,
                                        borderRadius: 1,
                                        overflow: 'hidden',
                                        mb: 1.5,
                                        border: `1px solid ${fileInfo.color}`,
                                        backgroundColor: '#f5f5f5',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        position: 'relative'
                                      }}
                                    >
                                      {/* Try to load image, but have fallback ready */}
                                      <img
                                        src={base_logo_url + doc.filePath}
                                        alt={doc.name || 'Document'}
                                        style={{
                                          width: '100%',
                                          height: '100%',
                                          objectFit: 'cover',
                                          display: 'block'
                                        }}
                                        crossOrigin='anonymous' // Add this for CORS
                                        referrerPolicy='no-referrer' // Helps with some CORS issues
                                        onError={e => {
                                          // Hide broken image
                                          e.target.style.display = 'none';
                                          // Show icon as fallback
                                          const iconElement =
                                            e.target.nextElementSibling;
                                          if (iconElement) {
                                            iconElement.style.display = 'flex';
                                          }
                                        }}
                                        onLoad={e => {
                                          // Fixed: added (e) parameter
                                          // Hide icon when image loads successfully
                                          const iconElement =
                                            e.target.nextElementSibling;
                                          if (iconElement) {
                                            iconElement.style.display = 'none';
                                          }
                                        }}
                                      />

                                      {/* Fallback icon - shown initially, hidden when image loads */}
                                      <Box
                                        sx={{
                                          position: 'absolute',
                                          top: 0,
                                          left: 0,
                                          right: 0,
                                          bottom: 0,
                                          display: 'flex',
                                          alignItems: 'center',
                                          justifyContent: 'center',
                                          backgroundColor: fileInfo.bgColor,
                                          color: fileInfo.color,
                                          zIndex: 1
                                        }}
                                      >
                                        {fileInfo.icon}
                                      </Box>
                                    </Box>
                                  ) : (
                                    <Box
                                      sx={{
                                        color: fileInfo.color,
                                        mb: 1.5,
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        width: 60,
                                        height: 60
                                      }}
                                    >
                                      {fileInfo.icon || (
                                        <DescriptionIcon
                                          sx={{ fontSize: 40 }}
                                        />
                                      )}
                                    </Box>
                                  )}

                                  <Chip
                                    label={fileInfo.label}
                                    size='small'
                                    sx={{
                                      mb: 1,
                                      backgroundColor: fileInfo.color,
                                      color: 'white',
                                      fontSize: '9px',
                                      height: 18,
                                      maxWidth: '100%',
                                      overflow: 'hidden',
                                      textOverflow: 'ellipsis'
                                    }}
                                  />
                                </Box>

                                <Box
                                  sx={{ width: '100%', textAlign: 'center' }}
                                >
                                  <Typography
                                    variant='caption'
                                    sx={{
                                      fontWeight: 500,
                                      overflow: 'hidden',
                                      textOverflow: 'ellipsis',
                                      whiteSpace: 'nowrap',
                                      width: '100%',
                                      fontSize: '11px',
                                      lineHeight: 1.2,
                                      display: 'block',
                                      color: 'text.primary'
                                    }}
                                  >
                                    {doc.name || 'Unnamed Document'}
                                  </Typography>

                                  {/* File type and extension */}
                                  <Box
                                    sx={{
                                      display: 'flex',
                                      justifyContent: 'center',
                                      alignItems: 'center',
                                      gap: 0.5,
                                      mt: 0.5
                                    }}
                                  >
                                    {/* <Typography
                                      variant='caption'
                                      sx={{
                                        fontSize: '9px',
                                        color: 'text.secondary',
                                        fontWeight: 400
                                      }}
                                    >
                                      {doc.fileType || 'Unknown Type'}
                                    </Typography> */}

                                    {fileExtension && (
                                      <>
                                        <Typography
                                          variant='caption'
                                          sx={{
                                            fontSize: '9px',
                                            color: 'text.secondary',
                                            fontWeight: 600,
                                            backgroundColor: 'rgba(0,0,0,0.05)',
                                            px: 0.5,
                                            borderRadius: 0.5,
                                            fontFamily: 'monospace'
                                          }}
                                        >
                                          {fileExtension}
                                        </Typography>
                                      </>
                                    )}
                                  </Box>

                                  {/* Size info if available */}
                                  {doc.fileSize && (
                                    <Typography
                                      variant='caption'
                                      sx={{
                                        fontSize: '9px',
                                        color: 'text.secondary',
                                        display: 'block',
                                        mt: 0.25
                                      }}
                                    >
                                      {formatFileSize(doc.fileSize)}
                                    </Typography>
                                  )}
                                </Box>
                              </CardContent>
                            </Card>
                          </Grid>
                        );
                      })}
                    </Grid>
                  ) : (
                    <Card
                      sx={{
                        py: 4,
                        mt: 2,
                        backgroundColor: '#f8f9fa',
                        border: '2px dashed #dee2e6'
                      }}
                    >
                      <CardContent sx={{ textAlign: 'center' }}>
                        <Folder
                          sx={{ fontSize: 48, color: '#6c757d', mb: 2 }}
                        />
                        <Typography
                          variant='body1'
                          color='text.secondary'
                          sx={{ mb: 1, fontWeight: 500 }}
                        >
                          No Documents Found
                        </Typography>
                        <Typography
                          variant='body2'
                          color='text.secondary'
                          sx={{ fontSize: '13px' }}
                        >
                          No documents have been uploaded for this claim yet.
                        </Typography>
                      </CardContent>
                    </Card>
                  )}
                </Box>
              </TabPanelX>
            </TabPanel>
          )}
      </Box>
    </div>
  );
}

export default ViewShipment;
